import * as React from "react";
import * as ReactDOM from "react-dom";
import { Login } from "../components/Login";
import * as Cookies from "js-cookie";
const queryString = require("query-string");
const queryVariables = queryString.parse(location.search);
if (queryVariables.email) {
    let input = document.querySelector('input[name="customer[email]"]');
    input.value = queryVariables.email;
}
const loginPlacement = document.getElementById("login-placement");
if (loginPlacement)
    ReactDOM.render(React.createElement(Login, null), loginPlacement);
const returnUrlCookieName = "return_url";
if (queryVariables.return_url) {
    Cookies.set(returnUrlCookieName, queryVariables.return_url);
}
if (queryVariables.checkout_url) {
    Cookies.set(returnUrlCookieName, queryVariables.checkout_url);
}
const returnUrlCookie = Cookies.get("return_url");
if (returnUrlCookie && returnUrlCookie != null) {
    const returnInput = document.createElement("input");
    returnInput.name = "return_to";
    returnInput.value = returnUrlCookie;
    returnInput.type = "hidden";
    const createCustomerForm = document.getElementById("create_customer");
    if (createCustomerForm) {
        createCustomerForm.appendChild(returnInput);
    }
    const captchaForm = document.querySelector(".shopify-challenge__container form");
    if (captchaForm) {
        captchaForm.appendChild(returnInput);
    }
    const activateForm = document.querySelector('form[action="/account/activate"]');
    if (activateForm) {
        activateForm.appendChild(returnInput);
    }
    const resetPasswordForm = document.querySelector('form[action="/account/reset"]');
    if (resetPasswordForm) {
        resetPasswordForm.appendChild(returnInput);
    }
    const loginForm = document.querySelector('form[action="/account/login"]');
    if (loginForm) {
        const checkoutInput = document.createElement("input");
        checkoutInput.name = "checkout_url";
        checkoutInput.value = returnUrlCookie;
        checkoutInput.type = "hidden";
        const rurl = sessionStorage.getItem("rurl");
        if (rurl)
            checkoutInput.value = rurl;
        Cookies.set(returnUrlCookieName, rurl);
        loginForm.appendChild(checkoutInput);
    }
    if (returnUrlCookie == location.pathname + location.search ||
        returnUrlCookie == location.href) {
        Cookies.remove(returnUrlCookieName);
    }
}
